// removed by extract-text-webpack-plugin
module.exports = {"this":"ScheduledAnnouncementsDialog__this___3LCOi","messageList":"ScheduledAnnouncementsDialog__messageList___1X2wH","dialogBodyWrapper":"ScheduledAnnouncementsDialog__dialogBodyWrapper___3rWVH"};


//////////////////
// WEBPACK FOOTER
// ./src/chat/components/styles/ScheduledAnnouncementsDialog.css
// module id = 2075
// module chunks = 4